import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-07fbfa04")

_pushScopeId("data-v-07fbfa04")
const _hoisted_1 = /*#__PURE__*/_createVNode("p", null, "Messages", -1)
const _hoisted_2 = { class: "header-actions" }
const _hoisted_3 = {
  key: 0,
  src: "/assets/noavatar.jpg"
}
const _hoisted_4 = { class: "no-results" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("No results")
const _hoisted_6 = {
  key: 0,
  src: "/assets/noavatar.jpg"
}
const _hoisted_7 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_navbar = _resolveComponent("navbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_avatar = _resolveComponent("ion-avatar")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_list_header = _resolveComponent("ion-list-header")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_bottombar = _resolveComponent("bottombar")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withId(() => [
          _createVNode(_component_navbar)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_row, { class: "content-container" }, {
            default: _withId(() => [
              _createVNode(_component_ion_col, { class: _ctx.chatRoomsClasses }, {
                default: _withId(() => [
                  _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.arrowBack,
                        class: "ion-margin",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.go(-1)))
                      }, null, 8, ["icon"]),
                      _hoisted_1,
                      _createVNode("div", _hoisted_2, [
                        (_ctx.refreshingChatRooms)
                          ? (_openBlock(), _createBlock(_component_ion_spinner, {
                              key: 0,
                              name: "crescent",
                              size: "small"
                            }))
                          : (_openBlock(), _createBlock(_component_ion_icon, {
                              key: 1,
                              icon: _ctx.refresh,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refreshChatRooms())),
                              size: "medium",
                              class: "ion-margin-end"
                            }, null, 8, ["icon"]))
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_row, { class: "search-input" }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_input, {
                        placeholder: "Search username",
                        modelValue: _ctx.searchValue,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchValue = $event)),
                        value: _ctx.searchValue,
                        onIonInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchValue = $event.target.value)),
                        onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.searchChatRooms(_ctx.searchValue)), ["enter"]))
                      }, null, 8, ["modelValue", "value"]),
                      (!_ctx.searchingChatRooms)
                        ? (_openBlock(), _createBlock(_component_ion_icon, {
                            key: 0,
                            size: "small",
                            icon: _ctx.search,
                            class: "ion-margin-end",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchChatRooms(_ctx.searchValue)))
                          }, null, 8, ["icon"]))
                        : _createCommentVNode("", true),
                      (_ctx.searchingChatRooms)
                        ? (_openBlock(), _createBlock(_component_ion_spinner, {
                            key: 1,
                            class: "ion-margin-end",
                            name: "dots"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (_ctx.chatRooms.length > 0)
                    ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.chatRooms, (item) => {
                            return (_openBlock(), _createBlock(_component_ion_item, {
                              key: item.id,
                              onClick: ($event: any) => (_ctx.getMessages(item))
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_ion_avatar, { class: "ion-margin-end" }, {
                                  default: _withId(() => [
                                    (item.avatar == '')
                                      ? (_openBlock(), _createBlock("img", _hoisted_3))
                                      : (_openBlock(), _createBlock("img", {
                                          key: 1,
                                          src: item.avatar
                                        }, null, 8, ["src"]))
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_label, null, {
                                  default: _withId(() => [
                                    _createVNode("h2", null, _toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_4, [
                    (_ctx.noResults)
                      ? (_openBlock(), _createBlock(_component_ion_label, {
                          key: 0,
                          class: "chatrooms-spinner"
                        }, {
                          default: _withId(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.refreshingChatRooms)
                      ? (_openBlock(), _createBlock(_component_ion_spinner, {
                          key: 1,
                          class: "chatrooms-spinner",
                          name: "dots"
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_ion_col, { class: _ctx.msgsClasses }, {
                default: _withId(() => [
                  (_ctx.headerTitle.length > 0)
                    ? (_openBlock(), _createBlock(_component_ion_list, {
                        key: 0,
                        class: "messages"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_list_header, { class: "messages-header" }, {
                            default: _withId(() => [
                              (_ctx.showMsgsBackBtn)
                                ? (_openBlock(), _createBlock(_component_ion_icon, {
                                    key: 0,
                                    icon: _ctx.arrowBack,
                                    size: "medium",
                                    class: "ion-margin-end",
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showChatRooms()))
                                  }, null, 8, ["icon"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_avatar, { class: "ion-margin-end" }, {
                                default: _withId(() => [
                                  (_ctx.headerAvatar == '')
                                    ? (_openBlock(), _createBlock("img", _hoisted_6))
                                    : (_openBlock(), _createBlock("img", {
                                        key: 1,
                                        src: _ctx.headerAvatar
                                      }, null, 8, ["src"]))
                                ]),
                                _: 1
                              }),
                              _createVNode("h4", null, _toDisplayString(_ctx.headerTitle), 1)
                            ]),
                            _: 1
                          }),
                          (!_ctx.gettingMessages)
                            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.messages, (item) => {
                                  return (_openBlock(), _createBlock("div", {
                                    key: item.id
                                  }, [
                                    (item.senderId === _ctx.user.uid)
                                      ? (_openBlock(), _createBlock(_component_ion_item, {
                                          key: 0,
                                          class: "ion-text-end msg"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_ion_label, { "text-wrap": "" }, {
                                              default: _withId(() => [
                                                _createTextVNode(_toDisplayString(item.message), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : (_openBlock(), _createBlock(_component_ion_item, {
                                          key: 1,
                                          class: "msg"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_ion_label, { "text-wrap": "" }, {
                                              default: _withId(() => [
                                                _createTextVNode(_toDisplayString(item.message), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.gettingMessages)
                    ? (_openBlock(), _createBlock(_component_ion_spinner, {
                        key: 1,
                        class: "chatrooms-spinner",
                        name: "dots"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isIOS || _ctx.isAndroid)
                    ? (_openBlock(), _createBlock(_component_ion_row, {
                        key: 2,
                        class: "message-input-mobile"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_input, {
                            placeholder: "Your message",
                            modelValue: _ctx.message,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.message = $event)),
                            value: _ctx.message,
                            onIonInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.message = $event.target.value)),
                            onKeyup: _cache[10] || (_cache[10] = _withKeys(($event: any) => (_ctx.sendMessage()), ["enter"])),
                            enterkeyhint: "send",
                            inputmode: "text"
                          }, null, 8, ["modelValue", "value"]),
                          (!_ctx.sendingMessage)
                            ? (_openBlock(), _createBlock(_component_ion_icon, {
                                key: 0,
                                size: "small",
                                icon: _ctx.paperPlane,
                                class: "ion-margin-start",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sendMessage()))
                              }, null, 8, ["icon"]))
                            : _createCommentVNode("", true),
                          (_ctx.sendingMessage)
                            ? (_openBlock(), _createBlock(_component_ion_spinner, {
                                key: 1,
                                class: "ion-margin-start",
                                name: "dots"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_ion_row, {
                        key: 3,
                        class: "message-input"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_input, {
                            placeholder: "Your message",
                            modelValue: _ctx.message,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.message = $event)),
                            value: _ctx.message,
                            onIonInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.message = $event.target.value)),
                            onKeyup: _cache[14] || (_cache[14] = _withKeys(($event: any) => (_ctx.sendMessage()), ["enter"])),
                            enterkeyhint: "send",
                            inputmode: "text"
                          }, null, 8, ["modelValue", "value"]),
                          (!_ctx.sendingMessage)
                            ? (_openBlock(), _createBlock(_component_ion_icon, {
                                key: 0,
                                size: "small",
                                icon: _ctx.paperPlane,
                                class: "ion-margin-start",
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sendMessage()))
                              }, null, 8, ["icon"]))
                            : _createCommentVNode("", true),
                          (_ctx.sendingMessage)
                            ? (_openBlock(), _createBlock(_component_ion_spinner, {
                                key: 1,
                                class: "ion-margin-start",
                                name: "dots"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_bottombar)
    ]),
    _: 1
  }))
})